import cookie from '../utils/cookie'
import config from '../config/config'
import Vue from 'vue'

function toast(text, time=2000, cb=null) {
    Vue.$vux.toast.show({
        type: "text",
        text: text,
        time: time,
        position: "bottom",
        onHide: () => {
            cb && cb.call(this)
        }
    });
}

export default {
    install(Vue, options){
        Vue.prototype.$api = config.api;
        Vue.prototype.$cookie = cookie;
        Vue.prototype.$config = config;
        Vue.prototype.$toast = toast;
    }
}



// WEBPACK FOOTER //
// ./src/plugins/globalFn.js